import React, { FC } from 'react';
import TextInput from '../TextInput';
import { SafeAreaView, TextInputProps } from 'react-native';
import styles from './styles';

type VerificationCodeInputProps = {
  errorMessage?: string | boolean;
  placeholderLabel?: string;
  value: string;
  onBlur?: Function;
  onChangeText: Function;
};

export type InputProps = VerificationCodeInputProps & TextInputProps;

export const VerificationCodeInput: FC<InputProps> = (props) => {
  const { errorMessage, onBlur, onChangeText, placeholderLabel, value } = props;
  return (
    <SafeAreaView>
      <TextInput
        autoCapitalize="none"
        autoCompleteType="off"
        errorMessage={errorMessage}
        imageKey={'check'}
        imageStyle={styles.imageStyle}
        keyboardType="default"
        label="Verification Code"
        labelHidden
        onBlur={onBlur}
        onChangeText={onChangeText}
        value={value}
        placeholder="Verfication Code"
      />
    </SafeAreaView>
  );
};

export default VerificationCodeInput;
